// eslint-disable-next-line import/no-named-as-default
import ConfirmPane from './view'

export default ConfirmPane
